if (!customElements.get("td-menu")) {
  class TdMenu extends HTMLElement {
    constructor() {
      super();

      this.TRIGGERS = Array.from(this.querySelectorAll("[data-td-trigger]"));
      this.handleDocumentPointerDown = this.handleDocumentPointerDown.bind(this);
    }

    connectedCallback() {
      this.initializeTriggers();
      this.attachListeners();
      document.addEventListener("pointerdown", this.handleDocumentPointerDown);
    }

    disconnectedCallback() {
      document.removeEventListener("pointerdown", this.handleDocumentPointerDown);
    }

    initializeTriggers() {
      this.TRIGGERS.forEach((trigger) => {
        if (this.isInitiallyOpen(trigger)) {
          this.openMenuItem(trigger);
        } else {
          this.closeMenuItem(trigger);
        }
      });
    }
    
    attachListeners() {
      this.TRIGGERS.forEach((trigger) => {
        const toggle = this.getToggle(trigger);

        trigger.addEventListener("mouseenter", () => {
          this.openMenuItem(trigger);
        });
        trigger.addEventListener("mouseleave", () => {
          setTimeout(() => {
            if (!trigger.matches(":focus-within")) {
              this.closeMenuItem(trigger);
            }
          }, 300);
        });
        trigger.addEventListener("focusin", () => {
          this.openMenuItem(trigger);
        });
        trigger.addEventListener("focusout", () => {
          setTimeout(() => {
            if (!trigger.contains(document.activeElement)) {
              this.closeMenuItem(trigger);
            }
          }, 0);
        });
        trigger.addEventListener("keydown", (event) => {
          if (event.key === "Escape") {
            this.closeMenuItem(trigger);
            if (toggle) {
              toggle.focus();
            }
          }
        });

        if (!toggle) {
          return;
        }

        toggle.addEventListener("click", (event) => {
          event.preventDefault();

          if (this.isOpen(trigger)) {
            this.closeMenuItem(trigger);
          } else {
            this.openMenuItem(trigger);
          }
        });
        toggle.addEventListener("keydown", (event) => {
          if (event.key !== "ArrowDown") {
            return;
          }

          event.preventDefault();
          this.openMenuItem(trigger);
          this.focusFirstSubmenuLink(trigger);
        });
      });
    }

    handleDocumentPointerDown(event) {
      if (this.contains(event.target)) {
        return;
      }

      this.closeAllMenuItems();
    }

    isInitiallyOpen(trigger) {
      return trigger.dataset.tdInitiallyOpen === "true";
    }

    getToggle(trigger) {
      return trigger.querySelector("[data-td-toggle]");
    }

    getSubmenu(trigger) {
      return trigger.querySelector("[data-td-submenu]");
    }

    getToggleLabel(trigger) {
      return trigger.querySelector("[data-td-toggle-label]");
    }

    isOpen(trigger) {
      const toggle = this.getToggle(trigger);

      return toggle ? toggle.getAttribute("aria-expanded") === "true" : false;
    }

    openMenuItem(trigger) {
      const submenu = this.getSubmenu(trigger);

      if (!submenu) {
        return;
      }

      this.closeAllMenuItems(trigger);
      trigger.classList.add("td-active");
      this.updateAriaState(trigger, true);
    }

    closeMenuItem(trigger) {
      const submenu = this.getSubmenu(trigger);

      if (!submenu) {
        return;
      }

      trigger.classList.remove("td-active");
      this.updateAriaState(trigger, false);
    }

    closeAllMenuItems(exception) {
      this.TRIGGERS.forEach((trigger) => {
        if (trigger === exception) {
          return;
        }

        this.closeMenuItem(trigger);
      });
    }

    updateAriaState(trigger, isOpen) {
      const toggle = this.getToggle(trigger);
      const submenu = this.getSubmenu(trigger);
      const toggleLabel = this.getToggleLabel(trigger);

      if (toggle) {
        toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
      }

      if (submenu) {
        submenu.setAttribute("aria-hidden", isOpen ? "false" : "true");
      }

      if (toggleLabel) {
        toggleLabel.textContent = isOpen
          ? toggleLabel.dataset.labelCollapse
          : toggleLabel.dataset.labelExpand;
      }
    }

    focusFirstSubmenuLink(trigger) {
      const submenu = this.getSubmenu(trigger);
      const firstLink = submenu ? submenu.querySelector("a, button, [tabindex]:not([tabindex='-1'])") : null;

      if (firstLink) {
        firstLink.focus();
      }
    }
  }

  customElements.define("td-menu", TdMenu);
}
